import {IntermediatePart} from "../../intermediatePart";
import {Vanity} from "../../parts/vanity";
import {createParentPositions, SIDE_POSITIONS, VANITY_TYPES} from "../../constants";

export default class Ptrap extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = 'vanity_ptrap';
    this.partName = 'Ptrap';
    this.translateId = "visualizer.bathroom.vanity.vanity_ptrap";
    this.visible = [Vanity.Types.Custom];
    // this.canBeDisabled = true;
    if (isChild) {
      createParentPositions(this);
    }
  }

  disabledClick() {
    this.toggleLayerPositions();
  }

  // handleClick(ignoreLocked) {
  //   const vanityParent = this.getParent().getParent();
  //   if ((vanityParent.vanity_type !== VANITY_TYPES.vanity_washstand && vanityParent.vanity_type !== VANITY_TYPES.vanity_console)) {
  //     if (vanityParent.vanityConsole && vanityParent.vanityConsole.activeFeature) {
  //       vanityParent.vanityConsole.disabled = false;
  //       vanityParent.vanity_type = VANITY_TYPES.vanity_console;
  //     } else if (vanityParent.vanityWashstand && vanityParent.vanityWashstand.activeFeature) {
  //       vanityParent.vanityWashstand.disabled = false;
  //       vanityParent.vanity_type = VANITY_TYPES.vanity_washstand;
  //     }
  //   }
  //   super.handleClick(ignoreLocked);
  //   vanityParent.updateVanityParts();
  // }

  hideLayerCondition() {
    const vanityParent = this.getParent();
    return (vanityParent.vanity_type === VANITY_TYPES.vanity_cabinet && (!vanityParent.vanityCabinet || !vanityParent.vanityCabinet.activeFeature))
    || (vanityParent.vanity_type === VANITY_TYPES.vanity_washstand && (!vanityParent.vanityWashstand || !vanityParent.vanityWashstand.activeFeature))
    || (vanityParent.vanity_type === VANITY_TYPES.vanity_console && (!vanityParent.vanityConsole || !vanityParent.vanityConsole.activeFeature))
  }

  // getArrayOfConditions() {
  //   const conditions = super.getArrayOfConditions();
  //   const activeMatchingSink = this.getParent().getActiveSkuFromRelatedItem("vanity_sink");
  //   if (activeMatchingSink) {
  //     conditions.push({
  //       propName: "MatchingFeature",
  //       propValue: activeMatchingSink
  //     });
  //   }
  //   console.log("conditions", conditions);
  //   console.log("this", this.activeFeature ? this.activeFeature.metaData : "");
  //   return conditions
  // }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    const vanityParent = this.getParent();
    const activeSideMeta = vanityParent.getActiveMatchingMetaFromRelatedItem(vanityParent.vanity_type, "Side");
    if (activeSideMeta && activeSideMeta.includes("C")) {
      conditions.push({
        propName: "Side",
        propValue: activeSideMeta
      });
    }
    // console.log("conditions", conditions);
    return conditions;
  }

  canDisplayDemoPoint(parentObject) {
    const vanityParent = this.getParent();
    return vanityParent.vanity_type && (vanityParent.vanity_type !== VANITY_TYPES.vanity_cabinet) && (parentObject.layerPosition !== SIDE_POSITIONS[0])
  }

}
